import { fetch as _fetch, buildUrl as _buildUrl } from 'omni-common-ui';

export const buildUrl = _buildUrl;
export const fetch = _fetch;
export const Api = { fetch, buildUrl };
export default Api;



// WEBPACK FOOTER //
// ./domain/Api/index.js